module.exports = __webpack_public_path__ + "static/media/bg.d3bea659.png";